// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"230":"915a1bd4","879":"0c748713"}[chunkId] + ".js";
};